import { Box } from "@mui/material";
import SubUserSignup from "../components/SubUserSignup";

import { useRoleLayout } from "../hooks/useRoleLayout";

const SubUserCreation = () => {
  const { Layout: RoleLayout } = useRoleLayout();

  return (
    <RoleLayout>
      <Box>
        <SubUserSignup />
      </Box>
    </RoleLayout>
  );
};

export default SubUserCreation;
